import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { GridRenderCellParams, GridTreeNodeWithRender } from "@mui/x-data-grid-premium";

export const EntityTableBooleanCell = (props: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>) => {
    if (props.value) {
        return <FontAwesomeIcon icon={MirageTheme.icons.checkIcon} />;
    }
    return null;
};
